<template><!-- 削除モーダル -->
<transition name="modal">
  <div class="modal-mask" @click="$emit('close')">
    <div class="modal-wrapper">
      <div class="modal-container">
        <div>
        <CRow>
        <CCol>
          <table class="table">
            <thead>
              <a style="font-size: 20px"><strong>削除内容確認</strong></a>
              <CCardText><strong>以下の内容を削除してよろしいですか？</strong></CCardText>
            </thead>
            <tbody>
              <tr>
                <td>
                  <a><strong>社員番号</strong></a><br>
                  {{ val.employee_id }}
                </td>
              </tr>
              <tr>
                <td>
                  <a><strong>氏名</strong></a><br>
                  {{ val.name }}
                </td>
              </tr>
              <tr>
                <td>
                  <a><strong>ユーザ種別</strong></a><br>
                  {{ val.authority_name }}
                </td>
              </tr>
              <tr>
                <td>
                  <a><strong>有給日数</strong></a><br>
                  {{ val.paid_days }}<block v-if="val.paid_days">日</block><block v-else></block>
                </td>
              </tr>
              <tr>
                <td>
                  <a><strong>代休日数</strong></a><br>
                  {{ val.comp_days }}<block v-if="val.comp_days">日</block><block v-else></block>
                </td>
              </tr>
              <tr>
                <td>
                  <a><strong>今期有休消化日数</strong></a><br>
                  {{ val.paid_days_used }}<block v-if="val.paid_days_used">日</block><block v-else></block>
                </td>
              </tr>
              <tr>
                <td>
                  <a><strong>有給付与月</strong></a><br>
                  {{ val.paid_days_add }}<block v-if="val.paid_days_add">月</block><block v-else></block>
                </td>
              </tr>
            </tbody>
          </table>
        </CCol>
        </CRow>
        <CRow>
          <CCol sm="10">
            <button @click="$emit('close')" class="btn btn-secondary btn-sm">キャンセル</button>
          </CCol>
          <CCol>
            <save-button
              :label="'削除'"
              :loading="loading"
              class="btn btn-danger"
              @click="$emit('delete')"
            />
          </CCol>
        </CRow>
        </div>
      </div>
    </div>
  </div>
</transition>
</template>

<script>
import SaveButton from '../common/SaveButton'
export default {
  components: { SaveButton },
  name: 'DeleteModal',
  data () {
    return {
    }
  },
  props: {
    val: Object,
    loading: Boolean,
  }
}
</script>

<style scoped>
  .modal-mask {
      position: fixed;
      z-index: 9998;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(80, 80, 80, 0.5);
      display: table;
      transition: opacity .3s ease;
    }
    .modal-wrapper {
      display: table-cell;
      vertical-align: middle;
    }
    .modal-container {
      width: 40%;
      margin: 0px auto;
      padding: 20px 30px;
      background-color: #fff;
      border-radius: 2px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
      transition: all .3s ease;
      font-family: Helvetica, Arial, sans-serif;
    }
</style>
